import type { MaybeRefOrGetter } from 'vue'
import {
  useResizeObserver as _useResizeObserver,
  type MaybeComputedElementRef,
  type MaybeElement,
  type UseResizeObserverOptions
} from '@vueuse/core'

export function useResizeObserver(
  target:
    | MaybeComputedElementRef
    | MaybeComputedElementRef[]
    | MaybeRefOrGetter<MaybeElement[]>,
  callback: ResizeObserverCallback,
  options?: UseResizeObserverOptions
) {
  return _useResizeObserver(target, callback, options)
}
